module.exports = __webpack_public_path__ + "127bc9bcc37bab3107c0192908c12bf9.MP3";